/**
 * The colour behind an account's initials, for an account with no picture on it. Derived
 * from the account itself, so the same person is always the same circle — a colour that
 * shuffled between launches would read as a different account.
 */

const AVATAR_COLORS = ['#D93025', '#E8710A', '#1E8E3E', '#1A73E8', '#9334E6', '#E52592']

export function avatarColor(seed: string): string {
  let hash = 0
  for (let index = 0; index < seed.length; index++) {
    hash = (hash * 31 + seed.charCodeAt(index)) | 0
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length] ?? '#1A73E8'
}

/**
 * The letters in the circle: the first and the last name's, since that is what a person is
 * called, or a placeholder before a name is known.
 */
export function avatarInitials(name: string | undefined): string {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean)
  const first = words[0]
  if (first === undefined) {
    return '?'
  }
  const last = words.length > 1 ? words[words.length - 1] : undefined
  return (first.charAt(0) + (last?.charAt(0) ?? '')).toUpperCase()
}
